/* Keep V27 pk-mega panels under their host and inside the viewport. */
(() => {
  'use strict';
  if (window.__printoraMegaPositionV27) return;
  window.__printoraMegaPositionV27 = true;

  const MQ = window.matchMedia('(min-width: 1025px)');

  function place(host) {
    if (!MQ.matches || !host) return;
    const panel = host.querySelector(':scope > .pk-mega');
    if (!panel) return;
    panel.style.left = '0px';
    panel.style.right = 'auto';
    panel.style.transform = 'none';
    const rect = panel.getBoundingClientRect();
    const overflow = rect.right - (window.innerWidth - 12);
    if (overflow > 0) {
      panel.style.transform = 'translateX(-' + Math.ceil(overflow) + 'px)';
    }
  }

  function bind() {
    document.querySelectorAll('#printora-sticky-header .pk-mega-host').forEach((host) => {
      if (host.dataset.megaPosBound === '1') return;
      host.dataset.megaPosBound = '1';
      host.addEventListener('mouseenter', () => place(host));
      host.addEventListener('focusin', () => place(host));
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bind, { once: true });
  } else {
    bind();
  }
  window.addEventListener('resize', () => {
    document.querySelectorAll('#printora-sticky-header .pk-mega-host:hover').forEach(place);
  });
})();
